import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Price } from "@/components/Price/price/price";

import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { Cashback as CashbackBase } from "./components/cashback/cashback";
import { Discount as DiscountBase } from "./components/discount/discount";
import { EveryDayLowPrice as EveryDayLowPriceBase } from "./components/everyDayLowPrice/everyDayLowPrice";
import { Pricing as PricingBase } from "./pricing";

const PricingDefault = () => {
    const {
        currentPrice,
        strikethroughPrice,
        currentConversionPrice,
        conversionUnit
    } = useECommerceProduct();

    return (
        <div className={cn("tw:flex")}>
            <Col xs={8}>
                <Row className={cn("tw:mb-2")}>
                    <PricingBase.WebOnly />
                </Row>
                <PricingBase.Discount>
                    <Row className={cn("tw:mb-2")}>
                        <DiscountBase.ProductLabel />
                    </Row>
                    <DiscountBase.PromotionPeriode />
                </PricingBase.Discount>
                <PricingBase.Cashback>
                    <Row className={cn("tw:mb-2")}>
                        <CashbackBase.ProductLabel />
                    </Row>
                    <Row className={cn("tw:text-sm tw:font-normal")}>
                        <CashbackBase.PriceAfterCashbackIsApplied />
                    </Row>
                    <Row className={cn("tw:text-sm tw:font-normal")}>
                        <CashbackBase.Information />
                    </Row>
                </PricingBase.Cashback>

                <PricingBase.EveryDayLowPrice>
                    <Row className={cn("tw:mb-2")}>
                        <EveryDayLowPriceBase.Image />
                    </Row>
                </PricingBase.EveryDayLowPrice>
            </Col>
            <Col xs={4}>
                <Price
                    className={cn("tw:ml-auto")}
                    price={currentPrice ?? 0}
                    strikeThroughPrice={strikethroughPrice}
                    conversionPrice={currentConversionPrice}
                    conversionUnit={conversionUnit}
                    size={"xl"}
                >
                    {strikethroughPrice && <Price.StrikeThrough />}
                    <Price.Main />
                    {currentConversionPrice && conversionUnit && (
                        <Price.Conversion />
                    )}
                </Price>
                <PricingBase.Recupel />
            </Col>
        </div>
    );
};

export { PricingDefault };
